<template>
  <div id="CodeExchange" @click="close">
    <transition name="scale">
      <div class="login_panel" @click.stop="Nofalse()">
        <div class="panel_left">
          <div class="panel_left_title">
            <img src="@/views/objIcon/MJ.png" alt="">
            MJ绘画
            <div class="logoName">中文站</div>
          </div>
          <div class="panel_left_plas">
            Ai绘画首选MJ绘画，行业公认出图质量最高的Ai绘画软件
          </div>
          <div class="panel_left_foot">
            <div>
              <p>{{ total_num }} <span>张</span></p>
              <span>昨日Ai绘图数量</span>
            </div>
            <div>
              <p>{{ docnum }} <span>张</span></p>
              <span>{{ currentMonth }}月{{ currentDate }}日Ai绘图数量</span>
            </div>
          </div>
        </div>
        <div class="panel_right">
          <div class="login_type" v-if="activeTabName=='tab_login'">
            <div @click="login_type= (login_type==1 ? 2 : 1)"
                 :class="['login_type_icon',login_type==1?'phone':'weixin']"></div>
            <div class="login_type_text">{{ login_type == 1 ? "账号密码登录" : "微信扫码安全登录" }}</div>
          </div>
          <div class="panel_body" v-if="activeTabName=='tab_login'">
            <div class="panel_title">
              <span class="title_text">{{ login_type == 1 ? "微信扫码注册或登录" : "账号密码登录" }}<img
                  class="free_icon" src="./img/icon_img_03.gif" alt=""></span>
            </div>
            <div class="panel_subtitle"><span class="subtitle_text">AI绘图，认准{{ site_name }}</span></div>
            <div class="code_wrap" v-if="login_type==1">
              <img v-if="code_url&&showCodeImg" class="code_img" :src="code_url" alt="">
              <div v-if="timerout" class="time_out_cover" flex-center @click="get_login_code"> 二维码已过期，点击刷新
              </div>
              <div class="img_loading">
                <svg class="text-black" xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 24 24">
                  <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2">
                    <path stroke-dasharray="2 4" stroke-dashoffset="6"
                          d="M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21">
                      <animate attributeName="stroke-dashoffset" dur="0.6s" repeatCount="indefinite"
                               values="6;0"></animate>
                    </path>
                    <path stroke-dasharray="30" stroke-dashoffset="30"
                          d="M12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3">
                      <animate fill="freeze" attributeName="stroke-dashoffset" begin="0.1s" dur="0.3s"
                               values="30;0"></animate>
                    </path>
                    <path stroke-dasharray="10" stroke-dashoffset="10" d="M12 8v7.5">
                      <animate fill="freeze" attributeName="stroke-dashoffset" begin="0.5s" dur="0.2s"
                               values="10;0"></animate>
                    </path>
                    <path stroke-dasharray="6" stroke-dashoffset="6" d="M12 15.5l3.5 -3.5M12 15.5l-3.5 -3.5">
                      <animate fill="freeze" attributeName="stroke-dashoffset" begin="0.7s" dur="0.2s"
                               values="6;0"></animate>
                    </path>
                  </g>
                </svg>
              </div>
            </div>
            <div class="phone_wrap" v-else>
              <div class="form_item" style="margin-bottom:16px;">
                <el-input v-model="form.phone" placeholder="请输入手机号" clearable></el-input>
              </div>
              <div class="form_item">
                <el-input v-model="form.password" type="password" autocomplete="off" placeholder="请输入登录密码"
                          clearable></el-input>
              </div>
              <!-- <div class="form_item"><el-input v-model="form.code" placeholder="请输入6位短信验证码"></el-input><div class="code_btn"><el-button style="width:108px;height:50px;" type="text" :disabled="!form.phone||coding" @click="getCode">{{ coding?'重新获取('+second+')':'获取验证码' }}</el-button></div></div> -->
              <el-button style="width:100%;" type="danger" @click="login" :disabled="!form.phone||!form.password">
                登录
              </el-button>
              <div class="login_reg" style="margin-top: 13px;">
                没有账号？<span
                  @click="activeTabName='tab_reg';form.code='';form.password='';form.password2=''">点此注册</span>&nbsp;&nbsp;&nbsp;&nbsp;忘记密码？<span
                  @click="activeTabName='tab_password';form.code='';form.password='';form.password2=''">找回密码</span>
              </div>
            </div>
          </div>
          <div class="panel_body panel_body2" v-else-if="activeTabName=='tab_reg'">
            <div class="panel_title" style="padding-top:15px;">
              <span class="title_text">新用户注册</span>
            </div>
            <!--                      <div class="phone_wrap" style="padding-top:15px;">-->
            <div class="phone_wrap">
              <div class="form_item">
                <el-input v-model="form.phone" placeholder="请输入手机号" clearable></el-input>
              </div>
              <div class="form_item">
                <el-input v-model="form.code" placeholder="请输入6位短信验证码"></el-input>
                <div class="code_btn">
                  <el-button style="width:108px;height:50px;" type="text" :disabled="!form.phone||coding"
                             @click="getCode">{{ coding ? '重新获取(' + second + ')' : '获取验证码' }}
                  </el-button>
                </div>
              </div>
              <div class="form_item">
                <el-input v-model="form.password" type="password" autocomplete="off" placeholder="请输入登录密码"
                          clearable></el-input>
              </div>
              <div class="form_item">
                <el-input v-model="form.password2" type="password" autocomplete="off" placeholder="请再次输入登录密码"
                          clearable></el-input>
              </div>
              <el-button style="width:100%;" type="primary" @click="login_reg"
                         :disabled="!form.phone||!form.code||!form.password||!form.password2">注册
              </el-button>
              <div class="login_reg">
                我有账号？<span
                  @click="activeTabName='tab_login';form.password='';form.password2='';login_type=2">账号登录</span> 或
                <span @click="activeTabName='tab_login';login_type=1">微信登录</span>
              </div>
            </div>
          </div>
          <div class="panel_body panel_body2" v-else>
            <div class="panel_title" style="padding-top:15px;">
              <span class="title_text">重置密码</span>
            </div>
            <div class="phone_wrap">
              <div class="form_item">
                <el-input v-model="form.phone" placeholder="请输入手机号" clearable></el-input>
              </div>
              <div class="form_item">
                <el-input v-model="form.code" placeholder="请输入6位短信验证码"></el-input>
                <div class="code_btn">
                  <el-button style="width:108px;height:50px;" type="text" :disabled="!form.phone||coding"
                             @click="getCode">{{ coding ? '重新获取(' + second + ')' : '获取验证码' }}
                  </el-button>
                </div>
              </div>
              <div class="form_item">
                <el-input v-model="form.password" type="password" autocomplete="off" placeholder="请输入新密码"
                          clearable></el-input>
              </div>
              <div class="form_item">
                <el-input v-model="form.password2" type="password" autocomplete="off" placeholder="请再次输入新密码"
                          clearable></el-input>
              </div>
              <el-button style="width:100%;" type="primary" @click="login_reset_passwrod"
                         :disabled="!form.phone||!form.code||!form.password||!form.password2">找回密码
              </el-button>
              <div class="login_reg">
                我有账号？<span
                  @click="activeTabName='tab_login';form.password='';form.password2='';login_type=2">账号登录</span> 或
                <span @click="activeTabName='tab_login';login_type=1">微信登录</span>
              </div>
            </div>
          </div>
          <!-- <div class="agreement2">系统维护，新用户暂停注册</div> -->
          <div class="agreement" :style="activeTabName=='tab_login'?'':'padding-top:23px;'"><span
              @click="agree = !agree" :class="['selct_icon',{'selected':agree}]"></span>同意并阅读 <a
              href="https://docs.qq.com/doc/p/dab4e5845c5a3a8aadc6556fe9f6cc7803b7cb9b" target="_blank">《{{ site_name }}网络服务协议》</a> 和 <a
              href="https://docs.qq.com/doc/p/d5bc65c646ea1d70ec02ac7884c76ed274369512" target="_blank">《{{ site_name }}用户隐私条款》</a></div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
export default {
  data() {
    return {
      str_uuid: "",
      showCodeImg: false,
      timer: null,
      active_tab: 0,
      phone: '',
      code: '',
      time_space: 0,
      msgtimer: null,
      can_phone_login: true,
      timerout: false,
      pay_time: 0,
      activeTabName: "tab_login",
      currentMonth: '', // 当前月份
      currentDate: '',  // 当前日期
      login_type: 1,
      site_name: "",
      code_url: "",
      agree: true,
      form: {
        phone: "",
        code: "",
        password: "",
        password2: ""
      },
      coding: false,
      appid: '',
      second: 60,
      docnum: 0,
      total_num: 0,
      is_ad:0
    }
  },
  created() {
    this.get_login_code()
    this.site_name = SITE_NAME
    const now = new Date();
    this.currentMonth = now.getMonth() + 1; // getMonth() 返回的月份是从 0 开始的，所以需要加 1
    this.currentDate = now.getDate();
    this.appid = APP_ID
    this.totalDongHua()
    console.log(this.$route.query)
  },
  methods: {
    go_main_site(){
      if (location.href.indexOf('www.midjournny.cn') > -1 || location.href.indexOf('www.mjhuahua.cn') > -1) {
      // if (location.href.indexOf('127.0.0.1') > -1 || location.href.indexOf('192.168.1.10') > -1) {
          this.getProfile()
          // location.href.replace("/")
          return
      }
        let msclkid = this.getCache("msclkid") || ""
        if(msclkid !== ""){
            window.uetq = window.uetq || [];window.uetq.push('event', 'signup', {});
            console.log("执行 必应注册上报", window.uetq)
        }
        let adaid = this.getCache("ad_account_id") || "" 
        let url = MAIN_URLROOT + "?adaid=" + adaid
        let path = location.pathname
        let arrange = this.$route.query.arrange || ''
        let relation = this.$route.query.relation || ''
         if(msclkid){
            url += "&msclkid=" + msclkid
        }
        url += '&path='+ path
        url += '&arrange='+ arrange
        url += '&relation='+ relation
        url += "&token=" + localStorage.getItem("token");
        location.href = url
    },
    addInvite() {
      // 添加邀请记录
      let send_user_id = localStorage.getItem("invite_id") || 0;
      if (send_user_id > 0) {
        this.$http.post(`/front/aimj/user/invite/`, {send_user_id: send_user_id}).then((res) => {
          localStorage.setItem("invite_id", 0)
        })
      }
    },
    get_login_code() {
      this.timerout = false
      this.pay_time = 0
      if (this.timer) {
        clearInterval(this.timer)
      }
      let bd_vid = this.getCache("bd_vid") || ""
      let qhclickid = this.getCache("qhclickid") || ""
      let sourceid = this.getCache("sourceid") || ""

      let ad_account_id = this.getCache("ad_account_id") || 0
      let site_id = this.getCache("site_id") || 0
      
      let keyword = localStorage.getItem("keyword") || "";
      let invite_id = localStorage.getItem("invite_id") || 0;
      let params = {
        ad_account_id: ad_account_id,
        invite_id: invite_id,
        site_id: site_id,
        keyword: keyword,
        bd_vid: bd_vid,
        qhclickid: qhclickid,
        sourceid: sourceid
      }
      this.$http.get(`/front/wx/imagecode/?authorizer_appid=${APP_ID}`, {params: params}).then(res => {
        this.code_url = res.data.res_img;
        this.str_uuid = res.data.str_uuid;
        let timer = setTimeout(() => {
          this.showCodeImg = true;
          clearTimeout(timer);
        }, 400)
        this.getLoginInfo();
      })
    },
    getLoginInfo() {
      this.timerout = false
      this.timer = setInterval(() => {
        let bd_vid = this.getCache("bd_vid") || "";
        let qhclickid = this.getCache("qhclickid") || "";
        let sourceid = this.getCache("sourceid") || "";

        let href = location.href
        let ad_account_id = this.getCache("ad_account_id") || 0
        let site_id = this.getCache("site_id") || 0
        let keyword = this.getCache("keyword") || ""
        let timestamp = localStorage.getItem("timestamp") || 0;

        if (href.indexOf(MAIN_URLROOT) <= -1) {
          ad_account_id = ad_account_id || AD_AID
        }
        let params = {
          str_uuid: this.str_uuid,
          ad_account_id: ad_account_id,
          site_id: site_id,
          keyword: keyword,
          timestamp: timestamp,
          bd_vid: bd_vid,
          qhclickid: qhclickid,
          sourceid:sourceid
        }
        this.$http.get(`/front/wx/imagecodelogin/`, {params: params}).then((res) => {
          if (res.data.is_auth_wxa == 1 && res.data.user_id && res.data.token) {
            localStorage.setItem("token", res.data.token);

            // // 执行 必应注册上报
            // let msclkid = this.getCache("msclkid") || ""
            // if(msclkid !== ""){
            //     window.uetq = window.uetq || [];window.uetq.push('event', 'signup', {});
            //     console.log("执行 必应注册上报", window.uetq)
            // }

            // this.getProfile();
            this.go_main_site()
            clearInterval(this.timer);
            this.timer = null
          }
        })
        this.pay_time += 3;
        if (this.pay_time >= 60) {
          this.pay_time = 0;
          clearInterval(this.timer);
          this.timerout = true;
        }
      }, 3000)
    },
    getProfile() {
      this.$http.get(`/front/user/profile/`, {
        params: {
          app_id: APP_ID
        }
      }).then(res => {
        if (res.status == '200') {
          this.$store.commit('setUserInfo', res.data)
          this.$store.commit('setIsLogin', true)
          this.$store.commit('setShowLogin', false)
          // location.href = '/'
          location.reload();
        }
      }).finally(() => {
        // 添加邀请
        this.addInvite()
      })
    },
    close() {
      this.$store.commit('setShowLogin', false)
      clearInterval(this.timer);
      this.timer = null
    },
    Nofalse() {
      //阻止父元素关闭时影响子元素
      // 无任何操作
    },
    tab_change(type) {
      console.log("tab_change=", type)
      this.active_tab = type
      if (this.msgtimer)
        clearInterval(this.msgtimer);
      if (this.timer)
        clearInterval(this.timer);
      this.timer = null
      this.msgtimer = null;
      this.phone = ''
      this.code = ''
      if (type == 0) {
        this.get_login_code()
      }
    },
    check_phone(phone) {
      // 定义手机号码的正则表达式
      if (!phone) {
        this.$toast("请填写手机号");
        return false;
      }
      const regex = /^1[3456789]\d{9}$/;
      if (!regex.test(phone)) {
        this.$toast("手机号码格式不正确");
        return false;
      } else {
        return true
      }
    },
    send_code() {
      if (this.time_space != 0) {
        return
      }
      let check_phone_res = this.check_phone(this.phone)
      if (!check_phone_res) {
        return
      }
      //如果手机号码校验通过
      this.$http.post(`/front/auth/smscode/`, {
        'phone': this.phone,
        'tpl_id': SMS_TPL_ID
      }).then(res => {
        if (res.status == '200') {
          this.$toast("验证码已发送，请注意查收");
          this.time_space = 60
          this.msgtimer = setInterval(() => {
            this.time_space--;
            if (this.time_space === 0) {
              clearInterval(this.msgtimer); // 清除定时器
            }
          }, 1000);
        } else {
          this.$message({
            message: res.message,
            type: 'warning',
          })
        }
      })
    },
    //手机号码登录
    login() {
      //登录

      let bd_vid = this.getCache("bd_vid") || "";
      let qhclickid = this.getCache("qhclickid") || "";
      let sourceid = this.getCache("sourceid") || "";

      let ad_account_id = this.getCache("ad_account_id") || 0
      let site_id = this.getCache("site_id") || 0

      let keyword = localStorage.getItem("keyword") || "";
      let data = {
        phone: this.form.phone,
        code: this.form.code,
        password: this.form.password,
        action: "autoreg",
        ad_account_id: ad_account_id,
        site_id: site_id,
        keyword: keyword,
        bd_vid: bd_vid, qhclickid: qhclickid, sourceid: sourceid,
        is_ad: this.is_ad
      }

      this.$http.post('/front/auth/login/phone/', data).then(res => {
        if (res.status == '200') {
          this.$message({
            message: '登录成功！',
            type: 'success'
          });
          localStorage.setItem("token", res.data.token);
          this.go_main_site()
          // this.clearFn();
          // this.getProfile();
          // //重新刷新页面
          // location.reload()
        } else {
          console.log(res.message)
          this.$message({
            message: res.message,
            type: 'warning',
          })
        }
      }).catch(res => {
        console.log(2222)
        this.$message({
          message: res.message,
          type: 'warning'
        });
        this.clearFn();
      })
    },
    scanCodeAgain() {
      this.timerout = false
      this.pay_time = 0
      clearInterval(this.timer);
      this.scanSuccessVisible = false
      this.isShow = false
      this.show(0)
    },
    clearFn() {
      this.coding = false;
      this.second = 60;
      clearInterval(this.timer);
    },
    getCode() {
      if (!this.testPhone()) {
        return;
      }
      this.coding = true;
      this.form.code = ""
      this.$http.post('/front/auth/smscode/', {
        'phone': this.form.phone,
        'tpl_id': SMS_TPL_ID
      }).then(res => {
        if (res.status === "200") {
          this.$message({
            message: '验证码发送成功！',
            type: 'success'
          });
        } 
      }).catch(res => {
        this.$message({
          message: res.message,
          type: 'warning'
        });
        // this.clearFn();
      })
      this.msgtimer = setInterval(() => {
        this.second--;
        if (this.second == 0) {
          clearInterval(this.msgtimer);
          this.coding = false;
          this.second = 60;
        }
      }, 1000)
    },
    login_reg() {
      // 注册
      let bd_vid = this.getCache("bd_vid") || "";
      let qhclickid = this.getCache("qhclickid") || "";
      let sourceid = this.getCache("sourceid") || "";

      let ad_account_id = this.getCache("ad_account_id") || 0
      let site_id = this.getCache("site_id") || 0

      let keyword = localStorage.getItem("keyword") || "";
      let data = {
        phone: this.form.phone,
        code: this.form.code,
        password: this.form.password,
        ad_account_id: ad_account_id,
        site_id: site_id,
        keyword: keyword,
        bd_vid: bd_vid, qhclickid: qhclickid, sourceid: sourceid,
        is_ad: this.is_ad
      }
      if (this.form.code.length != 6) {
        this.$message({
          message: "请输入6位验证码",
          type: 'warning'
        });
        return false;
      }
      if (this.form.password !== this.form.password2) {
        this.$message({
          message: "两次密码输入不一样",
          type: 'warning'
        });
        return false;
      }
      this.$http.post('/front/auth/reg/', data).then(res => {
        this.clearFn();
        this.$message({
          message: '注册成功！',
          type: 'success'
        });
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("user_id", res.data.user_id);

        // 执行 必应注册上报
        // let msclkid = this.getCache("msclkid") || ""
        // if(msclkid !== ""){
        //     window.uetq = window.uetq || [];window.uetq.push('event', 'signup', {});
        //     console.log("执行 必应注册上报", window.uetq)
        // }

        // this.getProfile();
        // let href = location.href
        // if (href.indexOf(MAIN_URLROOT) > -1) {
        //   location.replace("/")
        // } else {
          // location.href = location.href
          this.go_main_site()
        // }
      }).catch(res => {
        this.$message({
          message: res.message,
          type: 'warning'
        });
        this.clearFn();
      })
    },
    login_reset_passwrod() {
      // 重置密码
      let data = {
        phone: this.form.phone,
        code: this.form.code,
        password: this.form.password
      }
      if (this.form.code.length != 6) {
        this.$message({
          message: "请输入6位验证码",
          type: 'warning'
        });
        return false;
      }
      if (this.form.password !== this.form.password2) {
        this.$message({
          message: "两次密码输入不一样",
          type: 'warning'
        });
        return false;
      }
      this.$http.post('/front/auth/resetpwd/', data).then(res => {
        this.clearFn();
        this.$message({
          message: '密码重置成功，请登录！',
          type: 'success'
        });
        this.form.password = ''
        this.form.password2 = ''
        this.activeTabName = "tab_login"
        this.login_type = 2

      }).catch(res => {
        this.$message({
          message: res.message,
          type: 'warning'
        });
        this.clearFn();
      })
    },
    testPhone() {
      if (!this.form.phone) {
        this.$message.error('请输入手机号');
        return false;
      }
      let myregphone = /^1[0-9]{10}$/;
      if (!myregphone.test(this.form.phone)) {
        this.$message.error('请输入正确的手机号');
        return false;
      } else {
        return true;
      }
    },
    totalDongHua() {
      this.$http.get(`/front/aimj/draw/num/`).then((res) => {
        this.total_num = res.data.total_num;
        this.total_num = Math.floor(Math.random() * 500) + res.data.today_doc_num;
        let today_doc_num = res.data.today_doc_num;

        let step = parseInt(today_doc_num / 20);
        let timer = setInterval(() => {
          this.docnum = this.docnum + step;
          if (this.docnum > today_doc_num) {
            this.docnum = today_doc_num;
            clearInterval(timer);
          }
        }, 100)
      })
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
#CodeExchange {
  position: fixed;
  width: 100%;
  height: 100%;
  bottom: 0;
  left: 0;
  transition: all 0.3s;
  background: rgba(0, 0, 0, 0.8);
  overflow: auto;
  animation: fadeInSlowAni 0.3s 1;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2500;

  .login_panel {
    width: 1000px;
    height: 500px;
    overflow: hidden;
    display: flex;
    background-color: #fff;

    .panel_left {
      width: 500px;
      flex-shrink: 0;
      background-image: url("./img/icon_img_01.png");
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      color: #575757;
      box-shadow: 2px 1px 7px #ccc;
      box-sizing: border-box;

      .panel_left_title {
        font-size: 25px;
        color: black;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        img {
          width: 50px;
          height: 50px;
        }
        .logoName{
          width: 60px;
          height: 24px;
          background: linear-gradient(to right,#f92c65,#9f2bf9);
          color: #fff;
          font-weight: 700;
          border-radius: 24px;
          // text-align: center;
          margin-left: 10px;
          font-size: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          line-height: 0;
        }
      }

      .panel_left_plas {
        font-size: 14px;
        margin-bottom: 50px;
      }

      .panel_left_foot {
        width: 100%;
        margin-top: 20px;
        display: flex;
        justify-content: space-evenly;

        div {
          display: flex;
          flex-direction: column;
          align-items: center;

          p {
            font-size: 20px;
            margin-bottom: 20px;
          }

          span {
            font-size: 14px;
          }
        }

        div:nth-child(2) {
          color: #ff2b2b;
        }
      }
    }

    .panel_right {
      flex-grow: 1;
      position: relative;

      .login_type {
        height: 38px;
        padding: 1px;

        .login_tabs {
          margin-left: 50px;
          width: 160px;
          float: left;
        }

        .login_type_icon {
          float: right;
          width: 36px;
          height: 36px;
          margin-left: 18px;
          background-size: 100% 100%;
          cursor: pointer;

          &.weixin {
            background-image: url("./img/icon_img_02.png");
          }

          &.phone {
            background-image: url("./img/img_icon_13.png");
          }
        }

        .login_type_text {
          float: right;
          height: 26px;
          line-height: 24px;
          border: 1px solid #f2999f;
          border-radius: 3px;
          background-color: #fac9c9;
          color: #ec3b3b;
          font-size: 12px;
          padding: 0 9px;
          margin-top: 9px;
          position: relative;

          &::after {
            content: "";
            display: block;
            position: absolute;
            top: 7px;
            border: 5px solid transparent;
            border-left-color: #f2999f;
            right: -10px;
          }
        }
      }

      .panel_body {
        text-align: center;
        position: relative;

        .panel_title {
          color: black;
          padding-top: 42px;
          line-height: 54px;
          font-size: 22px;

          .title_text {
            position: relative;

            .free_icon {
              position: absolute;
              right: -28px;
              top: -22px;
            }
          }
        }

        .panel_subtitle {
          font-size: 14px;
          line-height: 42px;
          margin-bottom: 22px;

          .subtitle_text {
            color: #ec3b3b;
            position: relative;

            &::before, &::after {
              content: "";
              display: block;
              width: 46px;
              height: 2px;
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
            }

            &::before {
              left: -57px;
              background-image: linear-gradient(to right, #f7f7f7, #dcdcdc);
            }

            &::after {
              right: -57px;
              background-image: linear-gradient(to right, #dcdcdc, #f7f7f7);
            }
          }
        }

        .code_wrap {
          display: block;
          margin: 0 auto;
          border: 2px solid #e6e6e6;
          width: 220px;
          height: 220px;
          padding: 10px;
          position: relative;

          .code_img {
            width: 100%;
            height: 100%;
            display: block;
            position: relative;
            z-index: 2;
          }

          .scan_result {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            text-align: center;
            padding-top: 36px;
            background-color: rgba(255, 255, 255, 0.95);
            z-index: 3;

            .success_icon {
              width: 70px;
            }

            .success_text {
              font-size: 18px;
              color: #07c160;
              line-height: 36px;
              padding-top: 10px;
            }

            .success_label {
              font-size: 15px;
              line-height: 35px;
            }

            .rescan_btn {
              display: inline-block;
              font-size: 14px;
              line-height: 34px;
              color: #576b95;
              cursor: pointer;
            }
          }

          .img_loading {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            .text-black {
              color: #000;
              display: block;
            }
          }

          .time_out_cover {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 5;
            cursor: pointer;
            background-color: rgba(0, 0, 0, 0.58);
            color: #fff;
            font-size: 15px;
            z-index: 10;

            &:hover {
              font-size: 16px;
              font-weight: bold;
            }

            display: flex;
            align-items: center;
            justify-content: center;
          }
        }

        .phone_wrap {
          width: 400px;
          margin: 0 auto;
          // height: 220px;
          .login_reg {
            color: #999;
            padding-top: 15px;

            span {
              color: #ec3b3b;
              cursor: pointer;
            }
          }

          .form_item {
            margin-bottom: 25px;
            position: relative;

            /deep/ .el-input__inner {
              height: 47.5px;
            }

            .code_btn {
              position: absolute;
              top: 0;
              right: 0;

              &::before {
                content: "";
                display: block;
                height: 24px;
                border-right: 1px solid #ddd;
                top: 13px;
                position: absolute;
                left: 0;
              }
            }
          }
        }
      }

      .panel_body2 {
        .phone_wrap {
          width: 400px;
          margin: 10px auto 0;
          // height: 220px;
          .login_reg {
            color: #999;
            padding-top: 38px;

            span {
              color: #ec3b3b;
              cursor: pointer;
            }
          }

          .form_item {
            //margin-bottom: 23px;
            margin-bottom: 16px;
            position: relative;

            /deep/ .el-input__inner {
              height: 47.5px;
            }

            .code_btn {
              position: absolute;
              top: 0;
              right: 0;

              &::before {
                content: "";
                display: block;
                height: 24px;
                border-right: 1px solid #ddd;
                top: 13px;
                position: absolute;
                left: 0;
              }
            }
          }
        }
      }

      .agreement2 {
        padding-top: 5px;
        font-size: 12px;
        color: #ec3b3b;
        font-weight: bold;
        text-align: center;
      }

      .agreement {
        padding-top: 32px;
        font-size: 12px;
        color: #aaa;
        line-height: 32px;
        text-align: center;
        user-select: none;

        .selct_icon {
          display: inline-block;
          vertical-align: middle;
          margin-top: -3px;
          border: 1px solid #ec3b3b;
          width: 14px;
          height: 14px;
          margin-right: 5px;
          border-radius: 2px;
          cursor: pointer;

          &.selected {
            background-size: 100% 100%;
            background-image: url("./img/icon_img_05.png");
            border: none;
          }
        }

        a {
          color: #999;
        }
      }
    }
  }
}

.scale-enter-active,
.scale-leave-active {
  transition: all 0.3s;
}

.scale-enter,
.scale-leave-to {
  transform: translate(-50%, -50%) scale(0.6);
  opacity: 0;
}
</style>